/*
Classic Web Workers use `importScripts` to load chunks. Unfortunately, due to internal
browser implementation, `importScripts` is synchronous and will block the worker thread.
This patch will prefetch the chunk script before calling `importScripts` to have better cache
hit rate and avoid blocking the worker thread for network load time.

We can remove this when we switch to using ES modules in the worker.
*/
declare var __webpack_get_script_filename__: (chunkId: number) => string;

let isPatched = false;

export function patchChunkLoad(): void {
    if (process.env.IS_WEBPACK && !isPatched) {
        isPatched = true;
        const webpackChunkLoad = __webpack_chunk_load__;
        const fetchedChunks = new Set();
        __webpack_chunk_load__ = async function (chunkId, callback) {
            if (!fetchedChunks.has(chunkId)) {
                const scriptName =
                    __webpack_public_path__ + __webpack_get_script_filename__(chunkId);
                try {
                    // import can fail synchronously in older browsers
                    await import(/* webpackIgnore: true */ scriptName);
                    fetchedChunks.add(chunkId);
                } catch {}
            }
            return webpackChunkLoad(chunkId, callback);
        };
    }
}
